import {
  ActionIcon,
  Flex,
  MantineProvider,
  useMantineTheme,
} from "@mantine/core";
import { IconArrowsDiagonal } from "@tabler/icons-react";

interface Props {
  fullscreen: boolean;
  openFullscreenModal: () => void;
}

export const OrderDesignPreviewBottomOverlay = ({
  fullscreen,
  openFullscreenModal,
}: Props) => {
  const theme = useMantineTheme();

  return (
    <MantineProvider theme={theme}>
      <Flex align="center" style={{ width: "100%" }}>
        <div style={{ flex: 1 }} />
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {!fullscreen && (
            <ActionIcon
              color={theme.primaryColor}
              key="zoom"
              variant="subtle"
              onClick={openFullscreenModal}
            >
              <IconArrowsDiagonal />
            </ActionIcon>
          )}
        </div>
      </Flex>
    </MantineProvider>
  );
};
